module.exports = __webpack_public_path__ + "img/default-winner-badge.ea7839c6.svg";